export default "__VITE_ASSET__C75cMu2e__"